import React from 'react';

const viSubtract = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      width: '1em',
      height: '1em',
      overflow: 'visible',
    }}
  >
    <g fill="none" fillRule="evenodd">
      <path fill="currentColor" d="M19 13H5v-2h14z" />
    </g>
  </svg>
);

export default viSubtract;
